import { makeVar, useReactiveVar } from '@apollo/client';

export type SidePanelState = 'expanded' | 'collapsed';

const sidePanelStateVar = makeVar<SidePanelState>('collapsed');

export const useSidePanel = () => {
  const sidePanelState = useReactiveVar(sidePanelStateVar);

  return {
    state: sidePanelState,
    isExpanded: sidePanelState === 'expanded',
    isCollapsed: sidePanelState === 'collapsed',
    open: () => {
      sidePanelStateVar('expanded');
    },
    close: () => {
      sidePanelStateVar('collapsed');
    },
    toggle: () => {
      sidePanelStateVar(
        sidePanelState === 'expanded' ? 'collapsed' : 'expanded',
      );
    },
  };
};
